// extracted by mini-css-extract-plugin
export default {"resend-button":"style_resend-button__iYkmD","resendButton":"style_resend-button__iYkmD"};